/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { CardStatusTag } from '@coursera/cds-core';
import type { IconProps } from '@coursera/cds-core';

type Props = {
  tagName: string;
  icon: React.ReactElement<IconProps>;
};

const TagWithIcon = ({ tagName, icon }: Props) => {
  return <CardStatusTag icon={icon}>{tagName}</CardStatusTag>;
};

export default TagWithIcon;
